import { AndroidInterface } from "@/services/android.service";

declare const Android: AndroidInterface;

interface WebkitMessageHandlers {
  showToast: {
    postMessage(payload: { message: string }): void;
  };
}

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: WebkitMessageHandlers;
    };
  }
}

const isIOS = (): boolean =>
  !!window.webkit?.messageHandlers?.showToast;

const isAndroid = (): boolean =>
  typeof Android !== "undefined" && !!Android.showToast;

export const showToast = (message: string): void => {
  if (isIOS()) {
    try {
      window.webkit!.messageHandlers!.showToast.postMessage({ message });
    } catch (error) {
      console.error("showToast iOS error:", error);
    }
  } else if (isAndroid()) {
    try {
      Android.showToast(message);
    } catch (error) {
      console.error("showToast Android error:", error);
    }
  } else {
    console.warn("showToast: Unsupported platform");
  }
};
